import React, { useState, useRef, useEffect } from 'react';
import { IoCloudUpload } from "react-icons/io5";
import { RiDeleteBin5Line } from "react-icons/ri";
import '../../components/DashboardSeller/UploadPO.css';
import { getAuthToken } from "../../utils/auth";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { createPurchaseOrder } from '../../API/Api';


const UploadPOBuyer = ({ isOpen, onClose, order, quotationId, onUploadSuccess }) => {
	const [files, setFiles] = useState([]);
	const fileInputRef = useRef();
	const [token, setToken] = useState(null);

	useEffect(() => {
		setToken(getAuthToken());
	}, []);

	if (!isOpen) return null;

	const handleFileChange = (e) => {
		const selectedFiles = Array.from(e.target.files);
		setFiles(prev => [...prev, ...selectedFiles]);
	};

	const handleFileRemove = (index) => {
		const updatedFiles = files.filter((_, i) => i !== index);
		setFiles(updatedFiles);
	};

	const handleSubmit = async () => {
		if (!files.length) {
			alert("Please select at least one file to upload.");
			return;
		}

		try {
			for (let file of files) {
				const formData = new FormData();
				formData.append('quotation_id', quotationId);
				formData.append('file', file);

				const response = await createPurchaseOrder(formData);

				console.log('Upload successful:', response);
			}

			toast.success("Files uploaded successfully.");
			onUploadSuccess?.();
			onClose(); // Optionally close the modal
			setFiles([]); // Clear after upload

		} catch (error) {
			console.error("Upload failed:", error);
			toast.error("Failed to upload file.");
		}
	};

	return (
		<div className="uploadpo-overlay">
			<ToastContainer position="top-right" autoClose={3000} />

			<div className="uploadpo-modal">
				<button className="uploadpo-close" onClick={onClose}>✖</button>

				<div className="uploadpo-container">
					<h3 className="uploadpo-label">Purchase Order</h3>

					<div className="payment-image-section">
						<div className="payment-upload-box" onClick={() => fileInputRef.current.click()}>
							<IoCloudUpload size={50} className="upload-icon" />
							<p className="upload-text">Browse Files to Upload</p>
							<p className="upload-format">(Format: JPG, PNG & PDF)</p>
							<input
								type="file"
								ref={fileInputRef}
								className="payment-file-input"
								accept=".jpg,.png,.pdf"
								multiple
								onChange={handleFileChange}
								style={{ display: 'none' }}
							/>
						</div>
					</div>

					{files.map((file, index) => (
						<div className="uploadpo-file-row" key={index}>
							<span className="uploadpo-filename">{file.name}</span>
							<RiDeleteBin5Line
								className="uploadpo-delete"
								size={18}
								onClick={() => handleFileRemove(index)}
							/>
						</div>
					))}
					<div className='main-button-po'>
						<button className="payment-modal-confirm-po font-poppins" onClick={handleSubmit}>Submit</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default UploadPOBuyer;